import {Notification} from '@gatewee/types/notification';

function normalizePanelUrl(url: string, panelPrefix: string): string {
  const trimmed = url.trim();
  if (trimmed.length === 0) {
    return trimmed;
  }
  return trimmed.startsWith('/') ? trimmed : `${panelPrefix}/${trimmed}`;
}

function resolveReportId(data: Record<string, unknown>): number | null {
  const reportId = data['reportId'];
  if (typeof reportId === 'number') {
    return reportId;
  }
  if (typeof reportId === 'string' && reportId.length > 0) {
    const parsed = Number(reportId);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

function getTaskNotificationHref(
  notification: Notification,
  panelPrefix: string,
): string | null {
  const url = notification.data['url'];
  if (typeof url === 'string' && url.trim().length > 0) {
    return normalizePanelUrl(url, panelPrefix);
  }

  const reportId = resolveReportId(notification.data);
  if (reportId !== null) {
    return `${panelPrefix}/reports/view/${reportId}`;
  }

  return null;
}

export function getNotificationHref(
  notification: Notification,
  panelPrefix = '/panel',
): string | null {
  if (
    notification.type === 'task.completed' ||
    notification.type === 'task.failed'
  ) {
    return getTaskNotificationHref(notification, panelPrefix);
  }

  if (notification.type === 'invoice.paid') {
    const invoiceId = notification.data['invoiceId'];
    if (typeof invoiceId === 'number') {
      return `${panelPrefix}/invoices/view/${invoiceId}`;
    }
    if (typeof invoiceId === 'string' && invoiceId.length > 0) {
      return `${panelPrefix}/invoices/view/${invoiceId}`;
    }
  }

  return null;
}
